import { Button, Modal } from "antd";
import { IconClose, IconQuestion } from "../../../../../../common/ui/icons";
import React from "react";
import "./FreightOrderModal.css";

const FreightOrderModal = ({ onCancel, visible, onClickYes, onClickNo }) => {
  return (
    <Modal
      onCancel={onCancel}
      visible={visible}
      width={432}
      closeIcon={<IconClose style={{ color: "#323232" }} />}
      title={
        <div className="ant-modal-header__title">
          <IconQuestion className="ant-modal-header__title-icon"/>
          <span className="ant-modal-header__title-text">Внимание!</span>
        </div>
      }
      footer={
        <>
          <Button
            style={{
              width: 176,
              color: "#00A8FF",
              borderColor: "#00A8FF"
            }}
            type="secondary"
            ghost
            size="large"
            onClick={onClickYes}
          >
            Да
          </Button>
          <Button
            style={{ width: 176, marginLeft: 16 }}
            type="primary"
            size="large"
            onClick={onClickNo}
          >
            Нет
          </Button>
        </>
      }
    >
      <p>Договор фрахтования уже заключен?</p>
      <p style={{ color: "#9b9b9b" }}>
        Если договор фрахтования не заключен, то сервис Teleportos сформирует и
        предложит типовой договор фрахтования. Он будет доступен заказчику в
        мобильном приложении Teleportos.
      </p>
    </Modal>
  );
};

export default FreightOrderModal;
